function csrfSafeMethod(method) {
  return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

function crossDomainRequest(url) {
  let origin_anchor = document.createElement("a");
  origin_anchor.href = location.href;

  let query_anchor = document.createElement("a");
  try {
    query_anchor.href = url;

    // Apparently required for IE 8-11
    // noinspection SillyAssignmentJS
    query_anchor.href = query_anchor.href;
    return origin_anchor.protocol + "//" + origin_anchor.host !==
        query_anchor.protocol + "//" + query_anchor.host;
  } catch (e) {
    return true;
  }
}

export {csrfSafeMethod, crossDomainRequest}



// WEBPACK FOOTER //
// ./assets/js/csrf.js